import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import apiRequest from '../utils/apiRequest';
import renderSectionContent from '../utils/renderSectionContent';
import getImage from '../utils/getImage';
import { Section, Sidebar, Content, StyledTitle, Ingress } from './Chapter';
import Footer from './Footer';
import NavBar from './NavBar';
import Logo from './Logo';
import {
  TinyText,
  TinyTitle,
  TinyTextWrapper,
  BaseLink
} from './CommonUiComponents';
import ImageBlock from './ImageBlock';
import findIdByPath from '../utils/findIdByPath';

const PageContent = styled(Content)`
  @media all and (max-width: 64rem) {
    margin-top: 4.5rem;
  }
`;

const TitleSection = styled.div`
  @media screen and (max-width: 64rem) {
    padding: 0 1.5rem;
    margin: 0 0 2rem;
  }
`;

class Page extends Component {
  state = {
    page: '',
    data: null
  };

  componentWillMount() {
    this.fetchData();
  }

  componentDidMount() {
    const { setIsOnWhitePage } = this.props;
    setIsOnWhitePage();
    window.scroll(0, 0);
    document.body.className = 'body-reset';
  }

  componentWillUnmount() {
    const { unsetIsOnWhitePage } = this.props;
    unsetIsOnWhitePage();
    document.body.className = '';
  }

  fetchData = async () => {
    const { slug } = this.props;
    const response = await apiRequest('wordpress', `wp/v2/pages?slug=${slug}`);
    this.setState({ data: response });
  };

  render() {
    const { bookCategory, bookTitle, bookId } = this.props;
    const { data } = this.state;

    if (!data) return null;
    if (data.length < 1) return null;

    const content = data[0];

    return (
      <div>
        <NavBar primary>
          <BaseLink to={`/bok/${bookId}`}>
            <Logo size="4.1875rem" />
          </BaseLink>

          <TinyTitle>{bookCategory}</TinyTitle>
          <TinyText italic>«{bookTitle}»</TinyText>
        </NavBar>
        {content.image &&
          content.image.medium !== null && (
            <Section fullWidth>
              <ImageBlock
                src={getImage(content.image, window.innerWidth)}
                alt={content.title.rendered}
                moreSpacing
              />
            </Section>
          )}
        <Section>
          {content.page_content.length > 0 &&
            content.page_content[0].sidebar_content.length > 0}
          <Sidebar alignment="center">
            <TinyTitle>Eksterne lenker</TinyTitle>
            <TinyTextWrapper
              dangerouslySetInnerHTML={{
                __html: content.page_content[0].sidebar_content[0].text
              }}
            />
          </Sidebar>
          <PageContent>
            <TitleSection>
              <StyledTitle>{content.title.rendered}</StyledTitle>
              <Ingress
                dangerouslySetInnerHTML={{ __html: content.summary }}
                noSpacing
              />
            </TitleSection>
          </PageContent>
        </Section>
        {content.page_content.map((s, k) => (
          <Section key={k}>
            {!s.fullWidth && (
              <Sidebar
                empty={!s.sidebar}
                alignment={
                  s.sidebar
                    ? content.slug === 'om-mitt-valg' &&
                      s.sidebar_content[k === 0 ? 1 : 0].alignement
                    : 'flex-start'
                }
              >
                {s.sidebar &&
                  s.sidebar_content.map(
                    (sd, j) =>
                      k === 0 && j === 0
                        ? null
                        : renderSectionContent(sd, j, content.page_content)
                  )}
              </Sidebar>
            )}
            <Content>
              {s !== null && renderSectionContent(s, k, content.page_content)}
            </Content>
          </Section>
        ))}
        <Footer bookId={findIdByPath()} />
      </div>
    );
  }
}

Page.propTypes = {
  setInvertedTheme: PropTypes.func.isRequired,
  unsetInvertedTheme: PropTypes.func.isRequired,
  bookCategory: PropTypes.string.isRequired,
  bookTitle: PropTypes.string.isRequired,
  bookId: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired
};

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page.js